import { Link } from "react-router-dom";

import Button from "../Button/Button";
import Slider from "../Slider/Slider";
import SubtitleSection from "../SubtitleSection/SubtitleSection";
import TitleSection from "../TitleSection/TitleSection";


import "./SectionRecommendations.css";
const SectionRecommendations = ({id}) => {
  return (
    <section className="sectionRecommendations" id={id}>
      <TitleSection titleSection={"Recomendaciones"} />
      <SubtitleSection
        subtitleSection={
          "Porque tus ojos, y los de quienes más quieres, merecen atención"
        }
      />
      <p className="paragraph-section">
        El cuidado visual no solo es importante para los adultos. Niños y
        jóvenes también pueden presentar cambios en su visión que influyen en su
        aprendizaje, concentración y bienestar.
      </p>
      <Slider />
      <div className="container-img">
        {" "}
        <Link to={"./empezar"} className="link">
          <Button text={"Test Visual"} className={""} />
        </Link>{" "}
        <p className="leyenda">
          Estos tests ofrecen una orientación general sobre tu visión, pero no
          reemplazan una valoración profesional. Si notas molestias persistentes
          o resultados fuera de lo habitual, te recomendamos acudir a un
          especialista.
        </p>
      </div>
    </section>
  );
};

export default SectionRecommendations;
